import { render, staticRenderFns } from "./ViewsSelection.vue?vue&type=template&id=6dc6a0f8"
import script from "./ViewsSelection.vue?vue&type=script&lang=js"
export * from "./ViewsSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports